/** @jsxRuntime classic */ /** @jsx createElement */ import { createElement } from '@fluentui/react-jsx-runtime';
import { assertSlots } from '@fluentui/react-utilities';
export const renderCheckbox_unstable = (state)=>{
    assertSlots(state);
    return /*#__PURE__*/ createElement(state.root, null, /*#__PURE__*/ createElement(state.input, null), state.labelPosition === 'before' && state.label && /*#__PURE__*/ createElement(state.label, null), /*#__PURE__*/ createElement(state.indicator, null), state.labelPosition === 'after' && state.label && /*#__PURE__*/ createElement(state.label, null));
};
